import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import { mq } from '@/features/theme';

const StyledBody = styled.div(() => {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',

    [mq.sm]: { alignItems: 'stretch' },
  };
});

interface IBodyProps {
  className?: string;
}

export const Body = ({
  children,
  className,
}: PropsWithChildren<IBodyProps>) => {
  return (
    <StyledBody
      className={className}
    >
      {children}
    </StyledBody>
  );
};
